// Custom Power Digital JS code
// GALLERY PDP TOGGLE TEST

document.addEventListener('DOMContentLoaded', function() {
const productGalleryButtons = document.querySelectorAll('[id^="button-product-gallery-"]');
productGalleryButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
        let galleryId = event.target.dataset.gallery;
        let gallery = document.querySelector(galleryId);
        
        productGalleryButtons.forEach((button) => {
            button.classList.toggle('pwd-btn_secondary');
            if(button.classList.contains('pwd-btn_secondary')){
            button.disabled = false;
            }else{
            button.disabled = true;
            }
        })
        
        const galleriesToggle = document.querySelectorAll('[id^="gallery-testimonial-"]');
        galleriesToggle.forEach((galleryToggle) => {
            galleryToggle.classList.toggle('pwd-test-opacity');
            })
        });
    });
});

// END GALLERY PDP TOGGLE TEST

// HEADER CLOSE MEGA-MENU

const megaMenus = document.querySelectorAll('.mega-menu__content-overlay');
megaMenus.forEach((menu) => {
    menu.addEventListener('click' , (e) => {
        document.getElementById(e.target.dataset.details).removeAttribute('open')
    })
})

// END HEADER CLOSE MEGA-MENU

// SUBSCRIPTION OPENER

const modalOpener = document.querySelector("#PDM-suscription-modal__opener");
const modalCloser = document.querySelector(".PDM-modal__close");
const siteHeader = document.querySelector(".site-header");
const modal = document.querySelector(".PDM-modal__container");

if(modalOpener) {
    modalOpener.addEventListener('click', () => {
        console.log('modal open')
        modal.setAttribute('open', '');
        siteHeader.style.zIndex = "0";
    })
}

if(modalCloser) {
    modalCloser.addEventListener('click', () => {
        console.log('modal open')
        modal.removeAttribute('open');
        siteHeader.style.zIndex = "99";
    })
}

const subscriptionButtons = document.querySelectorAll('[id^="suscription-button--"] summary');
const estheticalAccordion = document.querySelectorAll('.PDM-variant--esthetical summary');

[...subscriptionButtons, ...estheticalAccordion].forEach((button) => {
    button.addEventListener('click' , (e) => {
        [...subscriptionButtons, ...estheticalAccordion].forEach((subscriptionButton) => {
            subscriptionButton.parentElement.removeAttribute('open');
        })
    })
})

const subscriptionInterval = setInterval(() => {
    const rechargeInputSubsave = document.querySelector('input[data-radio-subsave]');
    const rechargeInputOnetime = document.querySelector('input[data-radio-onetime]');
    if (rechargeInputSubsave && rechargeInputOnetime) {
        subscriptionButtons.forEach((button) => {
            button.style.pointerEvents = 'all';
        });
        clearInterval(subscriptionInterval);
    }
}, 1000);

// END SUBSCRIPTION OPENER